import { CalendarCheck, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function CallToAction() {
  return <section data-section-id="260504" id="call-to-action" className="bg-primary-dark py-20 md:py-32 px-6 md:px-12 lg:px-24 flex items-center justify-center">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center space-y-8">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-white tracking-tight">
          Request Your Free Estimate Today
        </h2>
        
        <p className="text-lg md:text-xl text-primary-light/90 font-sans max-w-2xl leading-relaxed">
          Ready to restore your sliding doors? Contact our expert team for a professional assessment and a transparent quote. We're here to help you get things moving smoothly again.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto pt-4">
          <Button asChild size="lg" className="w-full sm:w-auto rounded-lg text-base h-14 px-8 bg-gradient-to-br from-primary to-secondary hover:shadow-strong transition-all">
            <Link to="/ContactUsPage">
              <CalendarCheck className="mr-2 size-5" />
              Get Started
            </Link>
          </Button>
          
          <div className="flex flex-col gap-2 w-full sm:w-auto">
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto rounded-lg text-base h-14 px-8 border-white/20 text-white hover:bg-white/10">
              <Link to="tel:+1-201-736-4633">
                <Phone className="mr-2 size-5" />
                201-736-4633
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto rounded-lg text-base h-14 px-8 border-white/20 text-white hover:bg-white/10">
              <Link to="tel:+1-646-406-4601">
                <Phone className="mr-2 size-5" />
                646-406-4601
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}